import { useEffect, useState } from 'react';

export const useWindowInnerSize = () => {
    const [width, setWidth] = useState(window.innerWidth);
    const [height, setHeight] = useState(window.innerHeight);

    useEffect(() => {
        const fn = () => {
            setWidth(window.innerWidth);
            setHeight(window.innerHeight);
        };

        window.addEventListener('resize', fn);

        return () => window.removeEventListener('resize', fn);
    }, [setWidth, setHeight]);

    return { width, height };
};
